import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function BirthdayCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("birthdayCard.title")}</h1>
      <p>{t("birthdayCard.intro")}</p>

      <CodeBlock title="birthdayImage()">{`import { birthdayImage } from "kira-arts";

const buffer = await birthdayImage(userId, {
  guildId,
  useRoleColor: true,
  age: 21,
  yearsInServer: 3,
  customMessage: "Wishing you an amazing day!",
});`}</CodeBlock>

      <h2>{t("birthdayCard.optionsTitle")}</h2>
      <CodeBlock title="BirthdayOptions">{`age?: number;
yearsInServer?: number;
customMessage?: string;
accentColor?: string;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
showUsername?: boolean;
guildId?: string;
bypassCache?: boolean;
theme?: KiraThemeName;`}</CodeBlock>

      <p>
        <Trans i18nKey="birthdayCard.note" components={[<code key="0" />, <code key="1" />]} />
      </p>

      <p>
        <Trans i18nKey="birthdayCard.messageNote" components={[<code key="0" />]} />
      </p>
    </article>
  );
}
